module.exports = __webpack_public_path__ + "static/img/business_digitization_vx.268f594.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/product/business_digitization_vx.png
// module id = fyps
// module chunks = 0